// @flow
import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';

import { DotsLoader } from 'app/common/components/Loader';
import type { PriceDiscountedRequestParams, PriceTypes } from 'app/common/api/general.types/tariff.pricediscounted';

import usePriceDiscounted from './usePriceDiscounted';
import styles from './PriceDiscounted.scss';


type Props = {
  className?: string,
  studentId: number,
  tariffId?: number,
  tariffBundleId?: number,
  priceType: PriceTypes,
  monthsNumber?: number,
}

const PriceDiscounted = ({
  className,
  studentId,
  tariffId,
  tariffBundleId,
  priceType,
  monthsNumber,
}: Props) => {
  if (!tariffId && !tariffBundleId) {
    console.error('PriceDiscounted: Один из параметров tariffId или tariffBundleId должен быть передан в компонент');
  }

  const [autoload, setAutoload] = useState(false);

  const params: PriceDiscountedRequestParams | null = useMemo(() => ((tariffBundleId || tariffId) ? {
    student_id: studentId,
    // $FlowFixMe
    ...(tariffBundleId ? { tariff_bundle_id: tariffBundleId } : {}),
    ...(tariffId && !tariffBundleId ? { tariff_id: tariffId } : {}),
    price_type: priceType,
    months_number: monthsNumber,
  } : null), [studentId, tariffId, tariffBundleId, priceType, monthsNumber]);

  const [price, loading] = usePriceDiscounted(params, autoload);

  return (
    <VisibilitySensor
      onChange={setAutoload}
      scrollCheck
      delayedCall
      partialVisibility
    >
      {loading
        ? <DotsLoader simple />
        : <span className={classNames(styles.root, className)}>
          {price || '???'}
        </span>}
    </VisibilitySensor>
  );
};

export default PriceDiscounted;
